<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col col-md-10 col-lg-8">
        <div class="row">
          <div class="col">
            <h1 v-if="consent.title" class="text-center">{{ consent.title }}</h1>
            <div v-if="consent.body" class="body" v-html="consent.body"></div>
          </div>
        </div>
        <div class="row justify-content-center" v-if="!confirmResponse">
          <div class="form-group col col-sm-3" v-for="response in consent.responses" :key="response.value">
            <button type="button" :id="response.value" class="btn btn-block text-capitalize" @click="confirmResponse = response">
              {{ response.text }}
            </button>
          </div>
        </div>
        <div class="row justify-content-center" v-if="confirmResponse">
          <div class="form-group col col-sm-3">
            <button type="button" id="confirm" class="btn btn-outline-secondary btn-block text-capitalize" disabled>
              {{ confirmResponse.text }}
            </button>
          </div>
          <div class="form-group col col-sm-3">
            <input type="text" readonly class="form-control-plaintext text-center text-capitalize" :value="$t('are-you-sure')" />
          </div>
          <div class="form-group col col-sm-3">
            <button type="button" id="yes" class="btn btn-block text-capitalize" @click="$emit('response', confirmResponse.value)">
              {{ $t("yes") }}
            </button>
          </div>
          <div class="form-group col col-sm-3">
            <button type="button" id="no" class="btn btn-block text-capitalize" @click="confirmResponse = null">
              {{ $t("no") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    consent: {
      title: String,
      body: String,
    },
  },
  data() {
    return {
      confirmResponse: null,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/base.scss";

.body {
  @extend .p-3;
  @extend .mb-4;
  @extend .border;

  max-height: 500px;
  overflow-y: auto;
  background-color: white;
}
</style>
